import { useState, useEffect } from 'react';
import { useLoginService } from 'service/login';
import { useStaffContext } from 'store';
import { useDataContext } from 'store/data';

const getCityName = (regions, cityId) => {
    const regionData = regions.find((region) => region.id === Number.parseInt(cityId, 10));
    return regionData?.name ?? '';
};

export const useCityName = () => {
    const [cityName, setCityName] = useState('');
    const { idToken } = useStaffContext();
    const { storageKeys } = useLoginService();
    const { regions, getRegions } = useDataContext();

    useEffect(() => {
        // 已經有 token，而且 regions 還沒撈過
        if (idToken.length > 0 && regions.length === 0) {
            getRegions();
        }
    }, [getRegions, idToken, regions]);

    // 取得縣市
    useEffect(() => {
        if (regions?.length > 0) {
            const cityId = sessionStorage.getItem(storageKeys.city);
            const newCityName = getCityName(regions, cityId);
            setCityName(newCityName);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [regions]);

    return cityName;
};
